import * as TabsPrimitive from '@radix-ui/react-tabs'
import * as React from 'react'

import { cn } from '@/ui/utils/style'

const Tabs = TabsPrimitive.Root

const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn('inline-flex w-full items-center justify-center border-panel-border border-b', className)}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger> & {
    indicatorClassName?: string
  }
>(({ className, children, indicatorClassName, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      'inline-flex w-full flex-grow flex-col items-center justify-center whitespace-nowrap px-0.5 font-semibold text-base opacity-50 transition-opacity duration-200 ease-in-out',
      'data-[state=active]:opacity-100 hover:opacity-70 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
      '[&>*]:data-[state=active]:opacity-100', // shows the blue bar for the active tab
      className,
    )}
    {...props}
  >
    {children}
    <div className={cn('mt-2 h-1 w-[calc(100%-1.5rem)] rounded-t-lg bg-nav-primary opacity-0', indicatorClassName)} />
  </TabsPrimitive.Trigger>
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      'ring-offset-background data-[state=active]:mt-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
      className,
    )}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsContent, TabsList, TabsTrigger }
